// extracted by mini-css-extract-plugin
module.exports = {"defaults":"_1ce1b79","withBackground":"_3ad296e"};